import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  ViewChild,
  ElementRef,
} from "@angular/core";
import { faExclamationTriangle } from "@fortawesome/free-solid-svg-icons";
import {
  VAIconRegistryService,
  exclamationTriangle,
} from "@va/core-library/icons";
import { createSelectedPeriodLabel } from "@va/core-library/period-filter";

@Component({
  selector: "app-create-new-comps-naming",
  templateUrl: "./create-new-comps-naming.component.html",
  styleUrls: ["./create-new-comps-naming.component.scss"],
})
export class CreateNewCompsNamingComponent implements OnInit {
  @Input() companyData;
  @Input() liData;
  @Input() type;
  @Input() YearTypeData;
  @Output() saveCompsName = new EventEmitter();
  @ViewChild("name") nameField: ElementRef;
  faExclamationTriangle = faExclamationTriangle;
  summaryData: any;
  companySummaryData: Array<string> = [];
  liSummaryData: Array<string> = [];
  compsNameError = "";
  CompsName = "";
  periodLabel = "";

  constructor(private iconRegistry: VAIconRegistryService) {
    this.iconRegistry.registerIcons([exclamationTriangle]);
  }

  ngOnInit() {
    for (let i = 0; i < this.companyData.length; i++) {
      const data = `${this.companyData[i].ticker} - ${this.companyData[i].full_name}`;
      this.companySummaryData.push(data);
    }
    for (let i = 0; i < this.liData.length; i++) {
      const data = `${this.liData[i].name}`;
      this.liSummaryData.push(data);
    }
    this.summaryData = [
      { title: "Companies", data: this.companySummaryData },
      {
        title: "Line Items",
        data: this.liSummaryData,
      },
    ];
    this.periodLabel = createSelectedPeriodLabel(this.YearTypeData);
  }

  ngAfterViewInit() {
    this.nameField.nativeElement.focus();
  }

  onChangeCompsName() {
    if (this.CompsName === "") {
      this.compsNameError = "Peer Analysis Table Name cannot be blank.";
    } else {
      this.compsNameError = "";
    }
    this.saveCompsName.emit(this.CompsName);
  }
}
